/* tslint:disable */
/* eslint-disable */
/**
 * MVC Games
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SendForgotPasswordEmailRequest
 */
export interface SendForgotPasswordEmailRequest {
    /**
     * A URL to the JSON Schema for this object.
     * @type {string}
     * @memberof SendForgotPasswordEmailRequest
     */
    readonly $schema?: string;
    /**
     * Email
     * @type {string}
     * @memberof SendForgotPasswordEmailRequest
     */
    email: string;
    /**
     * Recaptcha token
     * @type {string}
     * @memberof SendForgotPasswordEmailRequest
     */
    recaptchaToken: string;
}

/**
 * Check if a given object implements the SendForgotPasswordEmailRequest interface.
 */
export function instanceOfSendForgotPasswordEmailRequest(value: object): value is SendForgotPasswordEmailRequest {
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('recaptchaToken' in value) || value['recaptchaToken'] === undefined) return false;
    return true;
}

export function SendForgotPasswordEmailRequestFromJSON(json: any): SendForgotPasswordEmailRequest {
    return SendForgotPasswordEmailRequestFromJSONTyped(json, false);
}

export function SendForgotPasswordEmailRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SendForgotPasswordEmailRequest {
    if (json == null) {
        return json;
    }
    return {
        
        '$schema': json['$schema'] == null ? undefined : json['$schema'],
        'email': json['email'],
        'recaptchaToken': json['recaptcha_token'],
    };
}

export function SendForgotPasswordEmailRequestToJSON(json: any): SendForgotPasswordEmailRequest {
    return SendForgotPasswordEmailRequestToJSONTyped(json, false);
}

export function SendForgotPasswordEmailRequestToJSONTyped(value?: Omit<SendForgotPasswordEmailRequest, '$schema'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
        'recaptcha_token': value['recaptchaToken'],
    };
}

